import React, {useState, useEffect} from 'react';
import {
    Paper,
    Typography,
    Box,
    Divider,
    Alert
} from '@mui/material';
import nunjucks from 'nunjucks';

// A sample context similar to the one provided by the backend for previewing.
const PREVIEW_CONTEXT = {
    user: {
        id: 'ABC123X',
        first_name: 'John',
        last_name: 'Doe',
    },
};

const EmailPreview = ({subjectTemplate, bodyTemplate, externalLink}) => {
    const [renderedSubject, setRenderedSubject] = useState('');
    const [renderedBody, setRenderedBody] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        try {
            // Render Subject
            const subject = nunjucks.renderString(subjectTemplate || '', PREVIEW_CONTEXT);
            setRenderedSubject(subject);

            // The backend automatically appends the survey link to the body.
            // We simulate that behavior here for an accurate preview.
            // Note: The final link will have a real user ID, not the placeholder.
            const linkText = externalLink
                ? `\n\nSurvey Link: ${externalLink}?user_id={{user.id}}`
                : '';
            const fullBodyTemplate = (bodyTemplate || '') + linkText;

            const body = nunjucks.renderString(fullBodyTemplate, PREVIEW_CONTEXT);
            setRenderedBody(body);

            setError(''); // Clear previous errors on successful render
        } catch (e) {
            // Display syntax errors from the template engine
            setError(e.message);
        }
    }, [subjectTemplate, bodyTemplate, externalLink]);

    return (
        <Paper elevation={2} sx={{p: 3, height: '100%', border: '1px solid', borderColor: 'divider'}}>
            <Typography variant="h6" gutterBottom>
                Live Email Preview
            </Typography>
            <Divider sx={{mb: 2}}/>

            {error ? (
                <Alert severity="error" sx={{whiteSpace: 'pre-wrap'}}>{error}</Alert>
            ) : (
                <Box>
                    <Box sx={{mb: 2}}>
                        <Typography variant="caption" color="text.secondary" component="div">
                            SUBJECT
                        </Typography>
                        <Typography variant="body1" sx={{fontWeight: 'bold'}}>
                            {renderedSubject}
                        </Typography>
                    </Box>
                    <Divider sx={{mb: 2}}/>
                    <Box>
                        <Typography variant="caption" color="text.secondary" component="div">
                            BODY
                        </Typography>
                        {/* Use whiteSpace: 'pre-wrap' to respect newlines from the template */}
                        <Typography variant="body2" component="div" sx={{mt: 1, whiteSpace: 'pre-wrap'}}>
                            {renderedBody}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Paper>
    );
};

export default EmailPreview;